import NextTopLoader from 'nextjs-toploader';

interface IPageTopLoadingBarProps {
  /**
   * To change the default color of TopLoader.
   */
  color?: string;
  /**
   * To allow for auto incrementing behavior for the TopLoader.
   */
  crawl?: boolean;
  /**
   * To increment delay speed in ms.
   */
  crawlSpeed?: number;
  /**
   * The animation settings using easing (a CSS easing string).
   */
  easing?: string;
  /**
   * The height of TopLoader in px.
   */
  height?: number;
  /**
   * To change initial position for the TopLoader in percentage, : 0.08 = 8%.
   */
  initialPosition?: number;
  /**
   * To render a smooth shadow for the TopLoader. (set to false to disable it)
   */
  shadowStyle?: string | false;
  /**
   * To show the TopLoader at bottom. (increase height for the TopLoader to
   * ensure it's visibility at the mobile devices)
   */
  showAtBottom?: boolean;
  /**
   * Wether to show the spinner or not.
   */
  showSpinner?: boolean;
  /**
   * The animation speed for the TopLoader in ms.
   */
  speed?: number;
  /**
   * Helps to include custom HTML attributes for the TopLoader.
   */
  template?: string;
  /**
   * This defines zIndex for the TopLoader.
   */
  zIndex?: number;
}

/**
 * -----------------------------------------------------------------------------
 * This renders a top loading bar while the page is being loaded in the background
 * showing incremental steps through the journey.
 * - This is built on top of `nextjs-toploader`.
 *
 * REF - https://www.npmjs.com/package/nextjs-toploader
 * TODO: Restyle this to use theme primitives to match the page theme.
 */
export function PageTopLoadingBar({
  color,
  crawl,
  crawlSpeed,
  easing,
  height,
  initialPosition,
  shadowStyle,
  showAtBottom,
  showSpinner,
  speed,
  template,
  zIndex,
}: IPageTopLoadingBarProps) {
  return (
    <NextTopLoader
      color={color || 'var(--color-primary-400)'}
      crawl={crawl}
      crawlSpeed={crawlSpeed || 200}
      easing={easing || 'ease'}
      height={height || 1.5}
      initialPosition={initialPosition || 0.08}
      shadow={
        shadowStyle ||
        '0 0 10px var(--color-primary-200),0 0 5px var(--color-primary-800)'
      }
      showAtBottom={showAtBottom || false}
      showSpinner={showSpinner || true}
      speed={speed || 200}
      template={template}
      zIndex={zIndex}
    />
  );
}
